export enum DueDateTypes {
  UPON_RECEIPT = 'UPON_RECEIPT',
  NET_15 = 'NET_15',
  NET_30 = 'NET_30',
  NET_45 = 'NET_45',
  NET_60 = 'NET_60',
  CUSTOM = 'CUSTOM',
}
